import styled from 'styled-components';
import media from 'src/styles/Media.styled';
import { CURSOR, FONT_FAMILY_REGULAR, SMALL_TEXT_PX, SECONDARY_FONT_COLOR } from 'src/styles/fonts/MCFontConstants';
import { DARK_NAVY_FONT_COLOR, FONT_FAMILY_DEMI, LARGE_TEXT_PX, PRIMARY_FONT_COLOR } from '../../../../styles/fonts/MCFontConstants';

export const FieldInventoryDashboardContainer = styled.div`
    height: ${({ bannerHeight }) =>
        bannerHeight
            ? `calc(100dvh - 4rem - ${bannerHeight})`
            : 'calc(100dvh - 4rem)'};
    display: flex;
    flex-direction: column;
    ${media.mobileDevice`
        height: ${({ bannerHeight }) =>
            bannerHeight
                ? `calc(100vh - ${bannerHeight})`
                : 'calc(100vh - 3.6rem)'};
        min-height: ${({ bannerHeight }) =>
            bannerHeight
                ? `calc(100vh - ${bannerHeight})`
                : 'calc(100vh - 3.6rem)'};
        margin-top: -3.6rem;
        background-color: ${(props) => props.theme.calendarBackgroundColor};
        padding-bottom: 0;
        overflow-y: auto;
        overflow-x: hidden;
        -webkit-overflow-scrolling: touch;
    `}
    /* Mobile landscape scroll support - iPhone 14, 12, SE, XR */
    @media only screen and (orientation: landscape) and (max-height: 430px) and (max-width: 932px) {
        height: 100vh;
        min-height: 100vh;
        margin-top: 0;
        padding-top: 0;
        overflow-y: scroll !important;
        overflow-x: hidden;
        -webkit-overflow-scrolling: touch;
        position: relative;
    }
    /* When the full-screen filter popup is open in landscape (touch), hide the
       pagination so it can't show through/over the overlay regardless of stacking context. */
    @media screen and (orientation: landscape) and (pointer: coarse) and (max-width: 1366px) {
        &:has([data-filter-popup]) [data-pagination-wrapper] {
            display: none !important;
        }
    }
`;

export const NoResultsMessage = styled.div`
  margin: 0 5px;
    ${media.mobileDevice`  
         margin: 0 16px;
    `}
`;

export const SearchContainer = styled.div`
    display: flex;
    align-items: center;
    width: auto;
    gap: 8px;
    flex: 0 1 auto;
    
    ${media.mediumDevice`
        flex-direction: row;
        align-items: center;
        gap: 8px;
        width: auto;
        flex: 0 1 auto;
    
        
    `}
    
    ${media.mobileDevice`
        flex-direction: column;
        align-items: stretch;
        gap: 4px;
        width: 100%;
        flex: 0 1 auto;
    `}
`;

export const FieldInventoryDashboardHeaderContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin: 0 10px;
    z-index: 101;
    ${media.mobileDevice`
        position: fixed;
        left: 0;
        width: 100%;
        margin: 0;
        top: ${({ bannerHeight }) =>
            bannerHeight ? `max(3.6rem, calc(${bannerHeight} - 61px))` : '3.6rem'};
        background-color: ${(props) => props.theme.calendarBackgroundColor};
        padding: 11px 16px 1rem 16px;
    `}
    /* Mobile landscape - fixed header at top */
    @media only screen and (orientation: landscape) and (max-height: 430px) and (max-width: 932px) {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        width: 100%;
        z-index: 100;
        background-color: ${(props) => props.theme.calendarBackgroundColor};
        padding: 8px 16px;
    }
`;

export const FieldInventoryDashboardContent = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
    overflow: hidden;
    background: #f5f5f5 0% 0% no-repeat padding-box;
    margin: 0 5px;
    @media only screen and (min-device-width: 768px) and (max-device-width: 1200px) {
        margin: 0;
        overflow: visible;
    }
    ${media.mobileDevice`
        display: block;
        flex-direction: column;
        width: 100%;
        padding: 0 0 200px 0;
        margin: 50px 0 0 0;
        background: #F5F5F5;
        min-height: auto;
        overflow: visible;
    `}
    /* Mobile landscape scroll for content - iPhone 14, 12, SE, XR */
    @media only screen and (orientation: landscape) and (max-height: 430px) and (max-width: 932px) {
        margin-top: 60px;
        padding-bottom: 100px;
        overflow: visible !important;
        min-height: unset;
    }
`;
export const HeaderContainer = styled.h2`
    display: flex;
    font-family: AvenirNextWorld Demi;
    padding: 16px 0 10px 0;
    margin: 0;
    color: #140f4b;

    ${media.mobileDevice`
        color: #FFFFFF;
        padding: 0;
        margin: 0;
    `}
`;

export const FilterContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    margin: 5px 16px 6px auto;
`;

export const FilterIconContainer = styled.div`
    position: relative;
    margin: 4px;
    height: 1.875rem;
    width: 1.875rem;
    ${media.mobileDevice`
    `}
`;

export const FilterIcon = styled.div`
    background: url(${(props) => props.deskPath});
    width: 100%;
    height: 100%;
    cursor: ${CURSOR};
    ${media.mobileDevice`
    background: url(${(props) => props.mobilePath});
    opacity: ${(props) => (props.isSearch ? '0.4' : '1')}
    `}
`;

export const FilterPopup = styled.div`
    position: absolute;
    top: calc(100% + 8px);
    right: 0;
    z-index: 1000;
    background: #ffffff;
    border-radius: 12px;
    box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.15);
    padding: 16px;
    min-width: 240px;
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

export const FilterPopupHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

export const FilterPopupTitle = styled.div`
    font-family: 'AvenirNextWorld Demi';
    font-size: 14px;
    color: #140f4b;
`;

export const FilterPopupApplyBtn = styled.button`
    align-self: flex-end;
    height: 32px;
    padding: 0 20px;
    border-radius: 20px;
    border: none;
    background: #1021eb;
    color: #ffffff;
    font-family: 'AvenirNextWorld Demi';
    font-size: 13px;
    cursor: pointer;
    &:hover {
        background: #0a18c2;
    }
`;
export const ContentSearch = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    flex-shrink: 0;
    width: 99%;
    margin-left: 5px;
    margin-top: 5px;
    background: ${({background}) => background || '#ffffff'};
    border-radius: 8px;
    padding: ${({padding}) => padding || '12px 12px'}; 
    box-shadow: ${({boxShadow}) => boxShadow || '0px 0px 6px #00000029'}; 
    gap: 12px;
    
    ${media.mediumDevice`
        flex-wrap: wrap;
        align-items: center;
        padding: ${({padding}) => padding || '12px 12px'};
    `}
    
    ${media.mobileDevice`
        flex-direction: row;
        flex-wrap: wrap;
        align-items: center;
        padding: ${({padding}) => padding || '12px 16px'};
        background: ${({background}) => background || '#FFFFFF'};
        border-radius: 0;
        box-shadow: none;
        margin: 12px 0 12px 0;
        width: 100%;
        gap: 8px;
    `}
`;
export const BodyTextContainer1 = styled.div`
    font-size: ${LARGE_TEXT_PX};
    font-family: ${FONT_FAMILY_DEMI};
    color: ${PRIMARY_FONT_COLOR};
    white-space: nowrap;
    flex: 0 0 auto;
    
    ${media.mediumDevice`
        margin-left: ${props => props.ipadMarginLeft ? props.ipadMarginLeft : '0'};
        flex: 0 0 auto;
    `}
    
    ${media.mobileDevice`
        margin-top: 0px;
        flex: 0 0 100%;
        width: 100%;
        font-size: ${({fontSize}) => fontSize ? fontSize : '14px'};
    `}
`;
export const FilterRow = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    flex-shrink: 0;
    gap: 8px;
    width: 99%;
    background: transparent;
    border-radius: 0;
    margin-top: 4px;
    padding: 10px 0;
    margin: 0 5px;
    ${media.mobileDevice`
        background: transparent;
        border-radius: 0;
        padding: 8px 16px;
        margin: 0;
        width: 100%;
        box-shadow: none;
        gap: 8px;
        flex-direction: column;
        align-items: flex-start;
    `}
`;

export const RefreshPromptWrapper = styled.div`
    margin-right: 8px;
    ${media.mobileDevice`
        margin-right: 0;
        display: contents;
    `}
`;

export const FilterRowRight = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-shrink: 0;
    justify-content: flex-end;
    gap: 8px;
    //padding-top: 6px;
    ${media.mobileDevice`
        width: 100%;
        justify-content: flex-end;
        gap: 8px;
        padding-top: 4px;
        flex-wrap: wrap;
    `}
`;

export const FilterRowLeft = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
    flex: 1;
    min-width: 0;
    overflow: hidden;
    padding-right: 12px;
    @media only screen and (min-device-width: 768px) and (max-device-width: 1200px) {
        min-width: 100%;
        padding-right: 0;
    }
    ${media.mobileDevice`
        width: 100%;
        overflow: visible;
        padding-right: 0;        
        flex-direction: column;
        align-items: stretch;
        gap: 4px;

        & [class*="MuiGrid-container"] {
            flex-wrap: nowrap !important;
            align-items: center;
            width: 100% !important;
        }
        & [class*="MuiGrid-container"] > [class*="MuiGrid-grid-xs-12"]:first-child {
            flex: 1 !important;
            min-width: 0 !important;
            max-width: none !important;
            flex-basis: auto !important;
        }
        & [class*="MuiGrid-container"] > [class*="MuiGrid-grid-xs-12"]:last-child {
            flex: 0 0 auto !important;
            max-width: none !important;
            flex-basis: auto !important;
            display: flex !important;
            align-items: center !important;
        }
        & [class*="MuiGrid-container"] > [class*="MuiGrid-item"] > div {
            padding: 0 !important;
            margin: 0 !important;
        }
        & [class*="MuiGrid-container"] > [class*="MuiGrid-item"] > div > div {
            margin-top: 0 !important;
        }
    `}
`;

export const FiltersSubRow = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 100%;
`;

export const RefreshButton = styled.button`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 32px;
    min-width: 100px;
    padding: 0 16px;
    border-radius: 20px;
    border: 1px solid #1021eb;
    background: #ffffff;
    color: #1021eb;
    font-family: 'AvenirNextWorld Demi';
    font-size: 13px;
    cursor: pointer;
    white-space: nowrap;
    flex-shrink: 0;
    &:hover {
        background: #1021eb;
        color: #ffffff;
    }
`;
export const ExportButton = styled.button`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 32px;
    min-width: 100px;
    padding: 0 16px;
    border-radius: 20px;
    border: 1px solid #1021eb;
    background: #ffffff;
    color: #1021eb;
    font-family: 'AvenirNextWorld Demi';
    font-size: 13px;
    cursor: pointer;
    white-space: nowrap;
    flex-shrink: 0;
    &:hover {
        background: #1021eb;
        color: #ffffff;
    }
`;

export const TableWrapper = styled.div`
    flex: ${({ $isSmallTable }) => $isSmallTable ? '0 1 auto' : '1'};
    min-height: 0;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    box-shadow: ${({ $isSmallTable }) => 
        $isSmallTable 
            ? '0px 2px 6px rgba(0, 0, 0, 0.1), 0px 0px 6px #00000029'
            : '0px -2px 6px rgba(0, 0, 0, 0.1), 0px 0px 6px #00000029'
    } !important;
    border-radius: ${({ $isSmallTable }) => $isSmallTable ? '8px' : '8px 8px 0 0'};
    margin-right: 5px !important;
    margin-left: 5px !important;
    ${media.mobileDevice`
        display: block;
        overflow: visible;
        min-height: 200px;
        background-color: #f5f5f5;
        margin: 0 !important;
        border-radius: 0;
        box-shadow: none !important;
    `}
`;

export const PaginationWrapper = styled.div.attrs({ 'data-pagination-wrapper': '' })`
    margin-top: ${({ $isSmallTable }) => $isSmallTable ? '8px' : 'auto'};
    ${media.mediumDevice`
        position: relative;
    `}
    ${media.mobileDevice`
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        width: 100%;
        z-index: 10;
        background-color: #ffffff;
        padding: 0px 0px 12px 0;
        margin: 0;
        box-shadow: 0px -2px 6px rgba(0, 0, 0, 0.1);
    `}
`;

export const DesktopView = styled.div`
    display: block;
    position: relative;
    margin: 0 5px 5px;
    z-index: 100;
    background-color: #ffffff;
    box-shadow: 0px -2px 6px rgba(0, 0, 0, 0.1);
    border-radius: 0 0 8px 8px;

    ${media.mobileDevice`
        display: none;
    `}
`;

export const MobileView = styled.div`
    display: none;
    ${media.mobileDevice`
        display: block;
        background-color: #FFFFFF;
        // box-shadow: 0px -3px 6px #00000014;
    `}
`;


export const ExportIconImg = styled.img`
    margin-right: 5px;
    width: 12px;
    height: 12px;

    ${ExportButton}:hover & {
        filter: brightness(0) invert(1);
    }
`;

export const ExportSpinnerWrapper = styled.span`
    display: inline-flex;
    align-items: center;
    gap: 8px;
`;

export const ContentBox = styled.div`
    flex: 1;
    width: 100%;
    background: #ffffff;
    border-radius: 6px;
    margin-top: 4px;
    min-height: 200px;
    overflow-y: auto;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.08);
`;

export const FilterChipsContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    align-items: center;
`;

export const FilterChip = styled.button`
    display: inline-flex;
    align-items: center;
    height: 30px;
    padding: 0 14px;
    border-radius: 20px;
    border: 1px solid ${({ isChecked }) => (isChecked ? '#1021eb' : '#c4c4c4')};
    background: ${({ isChecked }) => (isChecked ? '#1021eb' : '#ffffff')};
    color: ${({ isChecked }) => (isChecked ? '#ffffff' : '#3c3c3c')};
    font-family: 'AvenirNextWorld Demi';
    font-size: 13px;
    cursor: pointer;
    white-space: nowrap;
    transition: background 0.15s, color 0.15s, border-color 0.15s;
    &:hover {
        border-color: #1021eb;
        color: ${({ isChecked }) => (isChecked ? '#ffffff' : '#1021eb')};
    }
`;

export const FilterSection = styled.div`
    display: none;
    align-items: center;
    flex-direction: row;
    width: 100%;
    gap: 8px;
    flex: 1 1 auto;
    flex-wrap: wrap;
    
    ${media.mediumDevice`
        display: none;
    `}
    
    ${media.mobileDevice`
        display: none;
    `}
`;

export const FilterText = styled.div`
    white-space: nowrap;
    font-size: ${SMALL_TEXT_PX};
    font-family: ${FONT_FAMILY_DEMI};
    color: ${DARK_NAVY_FONT_COLOR};
    margin-right: 10px;
    flex: 0 0 auto;
    
    ${media.mediumDevice`
        margin-right: 10px;
        margin-left: ${props => props.ipadMarginLeft ? props.ipadMarginLeft : '0'};
        flex: 0 0 auto;
    `}
    
    ${media.mobileDevice`
        margin-top: 0px;
        margin-right: 0px;
        flex: 0 0 auto;
    `}
`;

export const SearchBoxContainer = styled.div`
    display: inline;
    justify-content: space-between;
    font-family: ${FONT_FAMILY_REGULAR};
    text-align: left;
    color: ${PRIMARY_FONT_COLOR};
    width: ${({ width }) => (width ? width : '100%')};
    align-items: center;
    flex: 1 1 auto;
    min-width: 200px;
    max-width: 462px;
    
    ${media.mediumDevice`
        width: auto;
        flex: 1 1 auto;
        min-width: 200px;
        max-width: 462px;
    `}
    
    ${media.mobileDevice`
        margin-left: 0px;
        margin-top: 0px;
        width: auto;
        flex: 1 1 0;
        min-width: 100px;
        max-width: none;
        
        .p-inputtext {
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
        }
    `}

    .p-input-icon-left > .p-inputtext {
        padding-left: 1.3rem;
    }
    .p-input-icon-right > .p-inputtext {
        padding-left: 1.3rem;
    }

    .p-input-icon-right > i:last-of-type,
    .p-input-icon-right > svg:last-of-type,
    .p-input-icon-right > .p-input-suffix {
        right: ${(props) => (props.searchIcon ? '19%' : '6%')};
        height: 21px;
    }
`;

export const SearchTypeDropdownContainer = styled.div`
    display: flex;
    width: 187px;
    min-width: 187px;
    flex: 0 0 auto;
    
    ${media.mediumDevice`
        width: 187px;
        min-width: 187px;
        flex: 0 0 auto;
    `}
    
    ${media.mobileDevice`
        width: 120px;
        min-width: 120px;
        flex: 0 0 120px;
    `}
`;

export const SearchTypeOptionLabel = styled.span`
    ${({ truncate }) => truncate && `
        display: block;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    `}
`;

export const TextArea = styled.textarea`
    resize: none;
    width: auto;
    height: ${({ height }) => (height ? height : '120px')};
    // margin-top: 20px;
    background: #ffffff 0% 0% no-repeat padding-box;
    border:  1px solid #b1b1bf;
    border-radius: 0px;
    font-family: ${FONT_FAMILY_REGULAR};
    letter-spacing: -0.11px;
    font-size: ${SMALL_TEXT_PX};
    padding: 10px 0 0 10px;
    // margin-bottom:12px;
    &::-webkit-input-placeholder {
    }
    &:focus {
        outline: none !important;
    }
    ${media.mobileDevice`
        // margin-top:12px;
        height: 120px;
        width: auto;
    `} 
`;
export const TextBold = styled.div`
    text-align: left;
    font-family: AvenirNextWorld Demi;
    color: ${(props) => props.color};
    font-size: 15px;
    margin-top: 0px;
    margin-bottom: 0px;
    letter-spacing: -0.12px;
    display: flex;
    align-self: center;
    margin: 0;
    padding: 0;
`;

export const ButtonsContainer = styled.div`
    display: flex;
    justify-content: flex-end;
    padding: 10px 0 0 0;
    background-color: #ffffff;
`;

export const LoadingOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
`;

export const PopupContentWrapper = styled.div`
    position: relative;
    min-height: 200px;
    display: flex;
    flex-direction: column;

    /* Style textarea text with secondary font color */
    .p-inputtextarea {
        color: ${SECONDARY_FONT_COLOR} !important;
    }

    ${media.mobileDevice`
       // padding: 24px 16px 18px 16px;
        .p-inputtextarea {
            max-height: 115px;
            color: ${SECONDARY_FONT_COLOR} !important;
        }
    `}
`;

export const PopupLoaderOverlay = styled.div`
    position: absolute;
    top: 0;
    left: -15px;
    right: -15px;
    bottom: -15px;
    background: #FFFFFF;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 100;
`;